import Markdown from "./Markdown";

export default function Message({ msg }) {
    return (
        <div className={`msg ${msg.from}`}>
            <div className="message-bubble">
                <Markdown content={msg.text} />
            </div>
        </div>
    );
}
